import React, { Component } from "react"

class RCT2ScenarioButton extends Component {
  showScenario = () => {
    this.props.readID(`${this.props.id}`)
  }
  
  render () {
    return (
      <li><button type="button" onClick={this.showScenario}>{this.props.name}</button></li>
    )
  }
}

export default RCT2ScenarioButton